/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Partner_Customer_Badge_DormantInputs */



/**
* | output |
* | --- |
* | "Starts {date}" |
*
* @param {Partner_Customer_Badge_DormantInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_customer_badge_dormant = /** @type {((inputs: Partner_Customer_Badge_DormantInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Customer_Badge_DormantInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Beginnt am ${i?.date}`)
	return /** @type {LocalizedString} */ (`Starts ${i?.date}`)
});